module.exports = __webpack_public_path__ + "./fonts/AbrilFatface-Regular.otf";